// extracted by mini-css-extract-plugin
export var copy = "page-header-module--copy--eb122";
export var image = "page-header-module--image--13f6f";
export var meta = "page-header-module--meta--fd443";
export var root = "page-header-module--root--efec5";
export var small = "page-header-module--small--1cd4d";
export var text = "page-header-module--text--bafe2";
export var title = "page-header-module--title--e200a";
export var white = "page-header-module--white--90516";